import React from 'react';
export function Guarantee() {
  return <section className="bg-white py-10" data-id="element-97" data-mp="7pf4bqpn0hze">
      <div className="mx-auto max-w-2xl px-6 text-center sm:px-8" data-id="element-98" data-mp="20ld41agynxig">
        <h3 className="font-heading text-2xl font-bold text-marino" data-id="element-99" data-mp="20jil21p92fh0">🛡️ Garantía de 7 Días</h3>
        <p className="mt-3 text-[15px] leading-relaxed text-gris-texto" data-id="element-100" data-mp="24l3sh7j0m1jt">
          Si tienes problemas para acceder al material, falta alguno de los contenidos anunciados o lo
          recibido no corresponde con la oferta mostrada en esta página, escríbenos a{' '}
          <a href="mailto:manualeslistos@gmail.com" className="font-medium text-azul underline" data-id="element-101" data-mp="2jat827ruu83m">
            manualeslistos@gmail.com
          </a>{' '}
          y lo resolveremos.
        </p>
        <p className="mt-4 text-sm font-semibold text-azul" data-id="element-102" data-mp="2sbrfz15eyzrh">
          Más de 9.000 entrenadores ya lo usan. Nuestra tasa de devolución es menor al 1%.
        </p>
      </div>
    </section>;
}